// extracted by mini-css-extract-plugin
module.exports = {"onOffButton":"AccionaOnOffButton_onOffButton__5PCbK","onState":"AccionaOnOffButton_onState__2Ra5B"};